// extracted by mini-css-extract-plugin
module.exports = {"link":"_640480","item":"_fc2117","alternatives":"_70c7e8"};